import { PureComponent, MouseEvent } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

import Badge from '@atlaskit/badge';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';

import { DropdownItem } from './dropdown-helpers';
import { messages } from './help-menu.i18n';
import * as styles from './whats-new-parent-item.style';

type Props = {
  newBlogCount: number;
  onClick: (e: MouseEvent<any>) => void;
  intl: IntlShape;
};

class WhatsNewParentItem extends PureComponent<Props> {
  handleClick = (e: MouseEvent<any>) => {
    // AkDropdownItem automatically closes the menu if the "href" prop is not present,
    // so here we explicitly stop the menu closing by keeping the href here and then
    // preventing default.
    e.preventDefault();
    this.props.onClick(e);
  };
  render() {
    const { newBlogCount, intl } = this.props;

    return (
      <DropdownItem
        href="#"
        onClick={this.handleClick}
        iconAfter={<ChevronRightIcon label="" />}
      >
        <styles.RightArrowDropdownItem>
          {intl.formatMessage(messages.whatsNewTitle)}{' '}
          {newBlogCount ? <Badge>{newBlogCount}</Badge> : null}
        </styles.RightArrowDropdownItem>
      </DropdownItem>
    );
  }
}

// eslint-disable-next-line import/no-default-export
export default injectIntl(WhatsNewParentItem);
